import { Logger } from '@/shared/logger/logger';
import { EBundleName } from '@/sources';

import { TagManagerWrapper } from '.';
import { TGtagInitConfig } from './types';

// Subclass for GA4
export class GA4Wrapper extends TagManagerWrapper {
  constructor(dataLayerName = 'gaLayer', gtagFunctionName = 'gaTag') {
    super(dataLayerName, gtagFunctionName);
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public initGA4(
    gaMeasurementId: string,
    googleTagId: string,
    custom_domain: string,
    _config: TGtagInitConfig = {},
    replaceRegex = false,
  ): void {
    if (!this.isValidId(gaMeasurementId, /^G-/)) {
      throw new Error(`Invalid GA4 Measurement ID ${gaMeasurementId}}`);
    }

    this.loadGtagScript(
      gaMeasurementId,
      googleTagId,
      custom_domain,
      replaceRegex,
      _config.isSgtmUrl,
    );

    this.gtagFunction('config', gaMeasurementId, {
      debug_mode: _config.debug_mode,
      send_page_view: Logger.bundleName === EBundleName.SHOPIFY_CUSTOM_PIXEL,
      transport_url: custom_domain ?? undefined,
    });

    this.initConsent();
  }
}
